import Vue from 'vue';
import {
  Form,
  FormItem,
  Container,
  Header,
  Aside,
  Main,
  Row,
  Col,
  Pagination,
  Tree,
  Empty,
  Loading,
  Notification,
  Tooltip,
  Checkbox,
  Table,
  TableColumn,
  Select,
  Option,
  Collapse,
  CollapseItem,
  Button,
  ButtonGroup,
  Dialog,
  Drawer,
  Input,
  InputNumber,
  DatePicker,
  Popover,
  RadioGroup,
  RadioButton,
  Progress,
  Breadcrumb,
  Slider,
  Tabs,
  TabPane,
  BreadcrumbItem,
  Rate,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Upload, //很特殊
  Radio,
  OptionGroup,
  Image,
  Message,
  Tag,
  Card,
  Divider,
  Switch,
  ColorPicker,
  MessageBox,
} from 'element-ui';
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Col);
Vue.use(Row);
Vue.use(Pagination);
Vue.use(Empty);
Vue.use(Tree);
Vue.use(Tooltip);
Vue.use(Loading.directive);
Vue.use(Checkbox);
Vue.use(ColorPicker);
Vue.use(Switch);
Vue.use(Divider);
Vue.use(Card);

Vue.use(Tag);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(Popover);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);


Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Slider);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Rate);
Vue.use(Collapse);
Vue.use(CollapseItem);

Vue.use(Image);
Vue.use(Drawer);
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
// $confirm(20261105补): 删除课件确认弹窗首次使用, 按需注册项目必须显式挂载(此前全项目未挂, 调用即静默TypeError无任何反应)
Vue.prototype.$confirm = MessageBox.confirm;

